import React from "react";
import { useSearchParams } from "react-router-dom";
import { InfoCard } from "../../components/info-card.tsx";

export function OwnerCheckEmail() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") ?? "";

  return (
    <InfoCard
      title="Check your email"
      description={
        <>
          We sent a sign-in link to{" "}
          <strong className="text-ink">{email || "that address"}</strong>. The
          link expires in 15 minutes and can only be used once.
        </>
      }
    >
      <p className="text-xs text-muted">
        If you don't see it, check your spam folder.
      </p>
    </InfoCard>
  );
}
